<template>
    <div class="col-lg-3 col-md-4 col-6 mb-3">
        <router-link :to="localePath('/testimonials/' + item.slug)">
            <img class="radious_eight" height="550" width="450" :src="item.front_image" :alt="item.your_full_name +'&'+ item.partner_full_name">
            <div class="rating_flex">
                <SvgHeaderSvg :type="'star'" v-for="index in item.experience" :key="index" />
            </div>
            <h3>{{item.your_full_name}} <span v-if="item.partner_full_name">& {{item.partner_full_name}}</span></h3>
            <p>{{item.address}}</p>
        </router-link>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const {item} = defineProps(['item'])
</script>

<style scoped>
.rating_flex {
    align-items: center;
    display: flex;
    margin-top: 4%;
}
a{
    color: #000;
}
h3 {
    font-size: 18px;
    line-height: normal;
    font-weight: 600;
    margin: 3% 0;
    color: #212529;
}
p {
    font-size: 16px;
    color: #6a6161;
    line-height: normal;
    margin-bottom: 7%;
}
@media(max-width: 992px){
    h3{
        font-size: 20px;
    }
    p{
        font-size: 14px;
    }
}
@media(max-width: 767px){

    h3{
        font-size: 16px;
        margin: 6% 0;
    }
    p{
        font-size: 13px;
        margin-bottom: 5%;
    } 
}
</style>
